import { render, staticRenderFns } from "./LeftInfo.vue?vue&type=template&id=fd008d34&scoped=true&"
var script = {}
import style0 from "./LeftInfo.vue?vue&type=style&index=0&id=fd008d34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd008d34",
  null
  
)

export default component.exports